import styled from "styled-components";

export const LoadingPageStyle = styled.div`

`;
